import React from 'react';

const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M16.6 8.6L12 13.2 7.4 8.6 6 10l6 6 6-6z" />
  </svg>
);

export default ChevronDown;
